import toast from "react-hot-toast"

export const notify = (message = "Toast", type = "error") => {
  const toastOptions = { position: "top-right" }

  // Handle different toast types properly
  switch (type) {
    case "success":
      return toast.success(message, toastOptions)
    case "error":
      return toast.error(message, toastOptions)
    case "info":
      // There's no direct info method in react-hot-toast
      return toast(message, { ...toastOptions, icon: "ℹ️" })
    case "loading":
      return toast.loading(message, toastOptions)
    case "warning":
      return toast(message, { ...toastOptions, icon: "⚠️" })
    default:
      return toast(message, toastOptions)
  }
}
